/**
 * Toggles debug mode by adding or removing the debug query-string parameter,
 * then reloads the page while preserving all other query-string values.
 */
$(document).ready(function () {
    $('#debug-btn').on('click', function () {
        var url = new URL(window.location.href);

        // Toggle the debug query-string parameter.
        if (url.searchParams.get('debug') === 'true') {
            url.searchParams.delete('debug');
        } else {
            url.searchParams.set('debug', 'true');
        }

        // Reload the page with the updated query string.
        window.location.href = url.toString();
    });
});